import * as Yup from 'yup';
import {
    SarlaftSecurity,
    SarlaftSecurityValidation,
} from '../../../../../../shared/types/modules/sarlaft';

export const initialValuesForm: SarlaftSecurity = {
    birthDateSise: '',
    birthDateClient: '',
    filterBirthDate: '',
    ageSise: '',
    ageClient: '',
    filterAge: '',
    statusValidation: '',
    observation: '',
    deliveryId: '',
    emailAccount: '',
    verificationCode: '',
    validationCode: false,
};

export const validationSchemaForm = (isVerificationCode: boolean) =>
    Yup.object({
        birthDateSise: Yup.string().required(
            'La fecha de nacimiento SISE es obligatoria'
        ),
        birthDateClient: Yup.string().required(
            'La fecha de nacimiento cliente es obligatoria'
        ),
        ageClient: Yup.string().required('La edad del cliente es obligatoria'),
        statusValidation: Yup.string().required(
            'El estado de validación es obligatorio'
        ),
        observation: Yup.string()
            .required('La observación es obligatoria')
            .max(
                4294967295,
                'La observación debe tener 4294967295 caracteres alfanuméricos como máximo'
            ),
        // Si es edición no se valida el código OTP
        verificationCode: isVerificationCode
            ? Yup.string().optional()
            : Yup.string().required('El código de verificación es obligatorio'),
    });

export const initialValuesValidationCode: SarlaftSecurityValidation = {
    verificationCode: '',
};

export const validationSchemaValidationCode = Yup.object({
    verificationCode: Yup.string().required(
        'El código de verificación es obligatorio'
    ),
});
